import { render, staticRenderFns } from "./hoofTrimming.vue?vue&type=template&id=156da91e&"
import script from "./hoofTrimming.vue?vue&type=script&lang=js&"
export * from "./hoofTrimming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports